import React, { useEffect, useState, useRef } from "react";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup, Tooltip } from "react-leaflet";
import dayjs from "dayjs";
import styles from "./styles_map.module.css";
import './styles.css';
import { useLazyGetReservoirHistoryGroupByListQuery } from "../../../../redux/api/reservoirHistory/reservoirHistoryApi";
import L, { LatLngTuple } from "leaflet";
import { PreloaderSvg } from "../../../preloaderSvg/PreloaderSvg";

interface IContentPart {
  latitude: number;
  longitude: number;
}

export const ReservoirMap = (props: IContentPart) => {
  const [geoData, setGeoData] = useState<any[]>([]);
  const [selectedReservoir, setSelectedReservoir] = useState<string | null>(null);
  const mapRef = useRef<any>(null);
  const [geoDataKR, setGeoDataKR] = useState<any>(null);

  const fetchGeoData = async (file: string, setGeoData: React.Dispatch<React.SetStateAction<any>>, label: string) => {
    try {
      const response = await fetch(`/${file}`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      if (data[0] && data[0].geojson) {
        setGeoData(data[0].geojson);
      } else {
        console.warn(`Данные geojson отсутствуют или неверный формат в ${label}:`, data);
      }
    } catch (error) {
      console.error(`Ошибка загрузки данных из ${label}:`, error);
    }
  };

  const [fetchReservoirData, { data , isLoading }] = useLazyGetReservoirHistoryGroupByListQuery();

  const fetchInitialData = () => {
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    fetchReservoirData({
      dateForDayFrom: yesterday,
      dateForDayTo: yesterday,
      reservoirId: null,
      deleted: false,
      page: 1,
      size: 100,
    });
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (data?.res?.content) {
      const geoJsonArray = data.res.content.flatMap((item: any) => {
        const reservoirsArray = Object.values(item.reservoirs || {});
        const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

        return reservoirsArray
          .filter((reservoir: any) => {
            const reservoirsDate = dayjs(item.dateForDay).format("YYYY-MM-DD");
            return (
              reservoirsDate === yesterday &&
              reservoir?.reservoir?.polygonJson
            );
          })
          .map((reservoir: any) => {
            try {
              const coordinates: [number, number][] = JSON.parse(
                reservoir.reservoir.polygonJson
              ).map((coord: number[]) => [coord[1], coord[0]]);

              return {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: [coordinates],
                },
                properties: {
                  id: reservoir.reservoir.id,
                  name: reservoir.reservoir.nameRu,
                  yearOfConstruction: reservoir.reservoir.yearOfConstruction,
                  designCapacity: reservoir.reservoir.designCapacity,
                },
              };
            } catch (error) {
              console.error(
                `Ошибка при разборе polygonJson для объекта с id=${reservoir?.reservoir?.id || "неизвестно"}:`,
                error
              );
              return null;
            }
          })
          .filter(Boolean);
      });

      setGeoData(geoJsonArray);
    }
  }, [data]);

  useEffect(() => {
    fetchGeoData("polygons/search.json", setGeoDataKR, "polygons/search.json");
  }, []);

  const handleReservoirClick = (center: LatLngTuple) => {
    mapRef.current?.flyTo(center, 12);
  };

  const getPolygonCenter = (coordinates: [number, number][]): LatLngTuple => {
    if (!coordinates || coordinates.length === 0) return [0, 0];
    const latSum = coordinates.reduce((sum, coord) => sum + coord[1], 0);
    const lngSum = coordinates.reduce((sum, coord) => sum + coord[0], 0);
    return [latSum / coordinates.length, lngSum / coordinates.length];
  };

  const onEachFeature = (feature: any, layer: any) => {
    const { id, name } = feature.properties || {};

    // const tooltipContent = `<b>Название:</b> ${name || "Не указано"}`;
    // layer.bindTooltip(tooltipContent, {
    //   sticky: true,
    //   direction: "top",
    // });

    layer.on("click", () => {
      const coordinates = feature.geometry?.coordinates?.[0];
      if (coordinates) {
        const center = getPolygonCenter(coordinates);
        handleReservoirClick(center);
      }
    });
  };

  const customIcon = new L.Icon({
    iconUrl: "/reservoir.svg",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
  });

  

  if (isLoading) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <PreloaderSvg />
        </div>
    );
}

  return (
    <div className={styles.mapContainer}>
      <div className={styles.button_statistics}>
        <button
          onClick={() => window.open('/allcharts', '_blank')}
          className={styles.button}
        >
          Вся статистика
        </button>
      </div>
      <MapContainer
        ref={mapRef}
        className={styles.map}
        center={[40.632559, 75.293580]}
        zoom={6}
        scrollWheelZoom={true}
        zoomControl={false}
      >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
        {geoData.map((geoJson, index) => {
          const coordinates = geoJson.geometry?.coordinates?.[0];
          if (!coordinates) return null;

          const center = getPolygonCenter(coordinates);

          return (
            <React.Fragment key={index}>
              <GeoJSON
                data={geoJson}
                style={{
                  color: "blue",
                  weight: 2,
                  opacity: 0.8,
                  fillOpacity: 0.4,
                }}
                onEachFeature={onEachFeature}
              />
              <Marker position={center} icon={customIcon}>
                <Popup>
                  <div className="popup-container" style={{
                    padding: '10px',
                    minWidth: '250px'
                  }}>
                    <h3 style={{ 
                      margin: '0 0 10px 0',
                      color: '#2c3e50',
                      borderBottom: '2px solid #3498db',
                      paddingBottom: '5px'
                    }}>
                      {geoJson.properties?.name || "Не указано"}
                    </h3>
                    
                    <div style={{ margin: '10px 0' }}>
                      <div style={{ 
                        display: 'flex',
                        marginBottom: '8px',
                        alignItems: 'center'
                      }}>
                        <span style={{ 
                          fontWeight: 'bold',
                          color: '#7f8c8d',
                          width: '140px'
                        }}>Год постройки:</span>
                        <span>{geoJson.properties?.yearOfConstruction || "Не указано"}</span>
                      </div>
                      
                      <div style={{ 
                        display: 'flex',
                        marginBottom: '8px',
                        alignItems: 'center'
                      }}>
                        <span style={{ 
                          fontWeight: 'bold',
                          color: '#7f8c8d',
                          width: '140px'
                        }}>Проектная мощность:</span>
                        <span>{geoJson.properties?.designCapacity || "Не указано"}</span>
                      </div>
                    </div>

                    <button
                      onClick={() => window.open(`/reservoir/statistics/${geoJson.properties?.id}`, "_blank")}
                      className="popup-button"
                    >
                      Перейти к статистике
                    </button>
                  </div>
                </Popup>
              </Marker>
            </React.Fragment>
          );
        })}
        {geoDataKR && (
          <GeoJSON
            data={geoDataKR}
            style={{ color: "grey", weight: 1, opacity: 0.5, fillOpacity: 0.3 }}
            onEachFeature={onEachFeature}
          />
        )}
      </MapContainer>

      <div className={styles.overlayTable}>
        <h3>Список водохранилищ</h3>
        <ul>
          {geoData.map((geoJson) => {
            const { name, id } = geoJson.properties || {};
            const coordinates = geoJson.geometry?.coordinates?.[0];
            if (!name || !id || !coordinates) return null;

            const center = getPolygonCenter(coordinates);

            return (
              <li
                key={id}
                onClick={() => handleReservoirClick(center)}
                className={
                  selectedReservoir === name ? styles.selected : ""
                }
              >
                <button className={styles.tableItem}>{name}</button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};